// extracted by mini-css-extract-plugin
export default {"wrapper":"Table_wrapper__std0K","ani":"Table_ani__qdy0t"};